import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

interface ActionButtonsProps {
  canEdit: boolean;
  onEdit: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ canEdit, onEdit }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Card 
      className="mb-4 action-buttons-card"
      style={{
        borderRadius: "18px",
        background: "var(--bs-card-bg)",
        boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        transition: "all 0.3s ease",
        overflow: "hidden",
        border: "1px solid var(--bs-border-color)"
      }}
    >
      <style>
        {`
          .action-buttons-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(0,0,0,0.12);
          }
          
          .action-button {
            transition: all 0.2s ease;
            border-radius: 8px;
            font-weight: 500;
            padding: 0.5rem 1.2rem;
          }
          
          .action-button:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          }
          
          .back-button {
            background-color: rgba(var(--bs-primary-rgb), 0.1);
            color: var(--bs-primary);
            border: none;
          }
          
          .back-button:hover {
            background-color: rgba(var(--bs-primary-rgb), 0.2);
            color: var(--bs-primary);
          }
        `}
      </style>
      <Card.Body className="d-flex flex-wrap justify-content-between align-items-center py-3 px-4">
        <div>
          <Button
            variant="outline-primary"
            className="action-button back-button"
            onClick={() => navigate("/inventory/history")}
          >
            <FontAwesomeIcon icon={faArrowLeft} className="me-2"/>
            {t("inventoryDetails.backToList")}
          </Button>
        </div>
        
        <div>
          <Button
            variant="primary"
            className="action-button px-4"
            onClick={onEdit}
            disabled={!canEdit}
            title={canEdit ? t("inventoryDetails.editTooltip") : t("inventoryDetails.editDisabledTooltip")}
          >
            <FontAwesomeIcon icon={faEdit} className="me-2" />
            {canEdit ? t("inventoryDetails.edit") : t("inventoryDetails.cannotEdit")}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ActionButtons;
